var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"bottom_text"},[_c('div',{staticClass:"left"},[_vm._v("杭州境缘文化传播有限公司  版权所有")]),_c('div',{staticClass:"right"},[_c('div',[_vm._v("地址：浙江省杭州市余杭区中泰街道跳头55号206室")]),_c('div',[_vm._v("网站备案：浙ICP备2025157073号")])])]),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }